// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "brand": {
      "column": {
        "default": null,
        "name": "brand",
        "null": true,
        "type": "string"
      },
      "name": "brand",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "exp_month": {
      "column": {
        "default": null,
        "name": "exp_month",
        "null": true,
        "type": "integer"
      },
      "name": "exp_month",
      "selected_by_default": null,
      "translated": null
    },
    "exp_year": {
      "column": {
        "default": null,
        "name": "exp_year",
        "null": true,
        "type": "integer"
      },
      "name": "exp_year",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "masked_number": {
      "column": null,
      "name": "masked_number",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeCard",
  "collectionKey": "stripe_cards",
  "collectionName": "stripe_cards",
  "i18nKey": "stripe_card",
  "camelizedLower": "stripeCard",
  "name": "StripeCard",
  "nameDasherized": "stripe-card",
  "pluralName": "stripe_cards",
  "ransackable_associations": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "stripe_customer_id",
      "name": "account",
      "macro": "has_one",
      "resource_name": "Account",
      "through": "stripe_customer"
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "address_city",
      "column": {
        "default": null,
        "name": "address_city",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_country",
      "column": {
        "default": null,
        "name": "address_country",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_line1",
      "column": {
        "default": null,
        "name": "address_line1",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_line1_check",
      "column": {
        "default": null,
        "name": "address_line1_check",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_line2",
      "column": {
        "default": null,
        "name": "address_line2",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_state",
      "column": {
        "default": null,
        "name": "address_state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_zip",
      "column": {
        "default": null,
        "name": "address_zip",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "address_zip_check",
      "column": {
        "default": null,
        "name": "address_zip_check",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "brand",
      "column": {
        "default": null,
        "name": "brand",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "country",
      "column": {
        "default": null,
        "name": "country",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "cvc_check",
      "column": {
        "default": null,
        "name": "cvc_check",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "dynamic_last4",
      "column": {
        "default": null,
        "name": "dynamic_last4",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "exp_month",
      "column": {
        "default": null,
        "name": "exp_month",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "exp_year",
      "column": {
        "default": null,
        "name": "exp_year",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "fingerprint",
      "column": {
        "default": null,
        "name": "fingerprint",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "funding",
      "column": {
        "default": null,
        "name": "funding",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "last4",
      "column": {
        "default": null,
        "name": "last4",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_customer_id",
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tokenization_method",
      "column": {
        "default": null,
        "name": "tokenization_method",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "stripe_card",
  "primaryKey": "id"
}

/** Frontend model for StripeCard. */
export default class StripeCard extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  brand() {
    return this.readAttributeUnderscore("brand")
  }

  /** @returns {boolean} */
  hasBrand() {
    const value = this.brand()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  expMonth() {
    return this.readAttributeUnderscore("exp_month")
  }

  /** @returns {boolean} */
  hasExpMonth() {
    const value = this.expMonth()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  expYear() {
    return this.readAttributeUnderscore("exp_year")
  }

  /** @returns {boolean} */
  hasExpYear() {
    const value = this.expYear()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  maskedNumber() {
    return this.readAttributeUnderscore("masked_number")
  }

  /** @returns {boolean} */
  hasMaskedNumber() {
    const value = this.maskedNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createCard(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_card",
        collectionName: "stripe_cards",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static publishableKey(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "publishable_key",
        collectionName: "stripe_cards",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  deactivate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "deactivate",
        primaryKey: this.primaryKey(),
        collectionName: "stripe_cards",
        type: "member"
      },
      commandArgs
    ))
  }
}
